import { defineStore } from "pinia";

export const useFormStore = defineStore("form", {
  state: () => {
    return {
      
      isSubmitted: false,
      isSuccess: false,
      formFields: {},
      formTouched: false,
      formErrors: [],
      fieldErrors: {},
      focusField: false,
      validate: {
        'formFields': {}
      },
      errors: false,
      errorMessages: {
        'required': 'This field is required',
        'email': 'Please enter a valid email address',
        'postcode': 'Please enter a valid postcode',
        'phone': 'Please enter a valid phone number',
        'minLength': 'Must be more than 0 characters',
        'maxLength': 'Must be less than 0 characters'
      },
      structure: {},
      quote: {},
      prefill: {},
      
    };
  },
  actions: {
    
  },
  getters: {
    
    hasStructure: (state) => {
      return !_.isEmpty(state.structure)
    },
    
  },
});